import type { Location } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { LinkElement } from '../nodes/LinkElement'

export const unwrapLink = (editor: BufferEditor, at: Location): void => {
  editor.tf.unwrapNodes({
    match: { type: LinkElement.type },
    at,
  })
}
